import React, {Component} from 'react';
import Action from 'components/organisms/used-players-list/actions';
import InputRadio from 'components/atoms/inputs/input-radio';
import {
    createOverallFilterPosition,
    createFilterPosition,
    isOverallFilterPosition,
} from 'components/organisms/filter-by-position/filter-position-interface';
import Tooltip from 'components/atoms/tooltip';
import Const from 'constants';

class BaseFilterComponent extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('FilterPosition', value));
    }

    getPositionTab(params) {
        const {value, title, isChecked, tooltipSubject = null} = params;

        return (
            <label className="tabs-chk" key={value.getKey()}>
                <InputRadio value={value} checked={isChecked} onChange={::this.onChange} />
                <span>
                    {title}
                    {tooltipSubject ? <Tooltip subject={tooltipSubject} /> : null}
                </span>
            </label>
        );
    }

    prepareTabs() {
        const {sportConfig, filters} = this.props;

        const tabs = [
            this.getPositionTab({
                value: createOverallFilterPosition(),
                title: 'All',
                isChecked: isOverallFilterPosition(filters.position),
            }),
        ];

        const canFlexPositionBeUsed =
            sportConfig.isSportCfb() ||
            (sportConfig.isSportNba() && sportConfig.isSiteDraftkings()) ||
            sportConfig.isSportNfl() ||
            sportConfig.isSportNhl() ||
            (sportConfig.isSportMlb() && sportConfig.isSiteFanduel());
        const positions = sportConfig.getFilter('positions', [], {withFlex: canFlexPositionBeUsed});

        positions.map((position) => {
            const tooltipSubject = inArray(position.key, ['FLEX', 'S-FLEX'])
                ? Const.FLEX_TAB_IN_EXPOSURE_BOX_TOOLTIP_SUBJECT
                : null;

            tabs.push(
                this.getPositionTab({
                    value: createFilterPosition(position),
                    title: position.key,
                    isChecked: filters.position.isKeyEqual(position.key),
                    tooltipSubject,
                }),
            );
        });

        return tabs;
    }
}

export {BaseFilterComponent};
